var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-margin-l h-padding-top-l h-padding-bottom-l h-bg-w h-full-card"},[_c('SearchRecipeContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }